<div class="dialog-title">
  <h2 class="dialog-title__text" mat-dialog-title *ngIf="!this.data.archived">
    {{ 'ARCHIVE_SECTOR_DIALOG.ARCHIVE.TITLE' | translate }}
  </h2>
  <h2 class="dialog-title__text" mat-dialog-title *ngIf="this.data.archived">
    {{ 'ARCHIVE_SECTOR_DIALOG.UNARCHIVE.TITLE' | translate }}
  </h2>
  <mat-icon class="dialog-title__icon" mat-dialog-close>close</mat-icon>
</div>

<div class="dialog-content">
  <p class="dialog-content__text" *ngIf="!this.data.archived">
    {{ 'ARCHIVE_SECTOR_DIALOG.ARCHIVE.DESCRIPTION' | translate }}
  </p>

  <p class="dialog-content__text" *ngIf="this.data.archived">
    {{ 'ARCHIVE_SECTOR_DIALOG.UNARCHIVE.DESCRIPTION' | translate }}
  </p>

  <mat-radio-group class="dialog-content__input" [(ngModel)]="selected">
    <mat-radio-button value="ARCHIVE_ENVIRONMENTS" *ngIf="!this.data.archived">
      <div class="dialog-content__input-label">
        {{ 'ARCHIVE_SECTOR_DIALOG.ARCHIVE.ARCHIVE_ENVIRONMENTS' | translate }}
      </div>
    </mat-radio-button>
    <mat-radio-button value="UNARCHIVE_ENVIRONMENTS" *ngIf="this.data.archived">
      <div class="dialog-content__input-label">
        {{ 'ARCHIVE_SECTOR_DIALOG.UNARCHIVE.UNARCHIVE_ENVIRONMENTS' | translate }}
      </div>
    </mat-radio-button>
    <mat-radio-button value="ARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS" *ngIf="!this.data.archived">
      <div class="dialog-content__input-label">
        {{ 'ARCHIVE_SECTOR_DIALOG.ARCHIVE.ARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS' | translate }}
      </div>
    </mat-radio-button>
    <mat-radio-button value="UNARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS" *ngIf="this.data.archived">
      <div class="dialog-content__input-label">
        {{ 'ARCHIVE_SECTOR_DIALOG.UNARCHIVE.UNARCHIVE_ENVIRONMENTS_AND_EQUIPMENTS' | translate }}
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>

<div class="dialog-actions">
  <button
    class="dialog-actions__button"
    mat-stroked-button
    color="primary"
    [disabled]="!selected || isLoading"
    *ngIf="!this.data.archived"
    (click)="updateArchived()"
  >
    <span *ngIf="!isLoading"> {{ 'ARCHIVE_SECTOR_DIALOG.ARCHIVE.ARCHIVE' | translate }} </span>
    <span class="dialog-actions__spinner" *ngIf="isLoading">
      <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
    </span>
  </button>

  <button
    class="dialog-actions__button"
    mat-stroked-button
    color="primary"
    [disabled]="!selected || isLoading"
    *ngIf="this.data.archived"
    (click)="updateArchived()"
  >
    <span *ngIf="!isLoading"> {{ 'ARCHIVE_SECTOR_DIALOG.UNARCHIVE.UNARCHIVE' | translate }} </span>
    <span class="dialog-actions__spinner" *ngIf="isLoading">
      <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
    </span>
  </button>

  <button
    class="dialog-actions__button field-background"
    color="primary"
    mat-flat-button
    mat-dialog-close
    [disabled]="isLoading"
  >
    <span> {{ 'ARCHIVE_SECTOR_DIALOG.CANCEL' | translate }} </span>
  </button>
</div>
